import React, { useState } from "react";

export default function ImgWithFallback({ src, alt = "", className = "", style = {} }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={className}
        style={{
          background: "#0A0A0B",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...style,
        }}
      >
        <img
          src="/logo.svg"
          alt="ShiaTunes"
          style={{ width: "60%", height: "60%", objectFit: "contain", opacity: 0.8 }}
        />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={() => setFailed(true)}
    />
  );
}
